import React,{useState} from "react";
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';

import { styled } from '@mui/system';
import { withStyles } from '@mui/styles';

import logo from './assets/logo.png'

import { useDispatch } from 'react-redux'
import { addauth } from './slices/authSlice.js'
import { setAuth } from './slices/dataSlice';
import {fetchFolders} from './slices/emailSlice.js'
import {APILogon} from './APIS/userAPI'

const StyledButton = styled(Button)(
    ({ theme }) => `
      background-color: ${theme.palette.mode === 'dark' ? '#004AAC' : '#004AAC'};
      color: ${theme.palette.mode === 'dark' ? '#ffffff' : '#ffffff'};
      ':hover': {
                backgroundColor: '#1D7CC2',
                color: '#ffffff'
        }
    `,
  );

const styles = {
    logonForm: {
        width: 300,
        height: 300,
        marginLeft: 'auto',
        marginRight: 'auto',
        border: '2px solid #004AAC',
        textAlign: 'center',
        marginTop: 100,
        paddingTop: 25
    },
    label: { marginTop: 20 },
    inputctl: { marginBottom: 10 },
    logo: { marginBottom: 20 }
}



const Logon = (props) => {
    const classes = props.classes
    const [username, setUsername] = useState('')
    const [password, setPassword]  = useState('')
    const [error, setError ]= useState('')
    const dispatch = useDispatch()


    const DoLogon = async () => {
        const ret = await APILogon(username,password)
        if(!ret.status ) {
            setError(ret.err)
            return
        }

        if(typeof ret.err !== 'undefined' && ret.err > "" ) {
            setError(ret.err)
            return
        }
        const data = ret.data
        if(data.token && data.name && data.email === username){
            // Update our Redux Store so we have security access throughout the app.
            const loggedon = {...data}
/*                token: d,
                _id:'',
                user._id:'',
                name:''
                email:'',
                security:1000,
                userstatus:'',
                user_group:'',
                dialler_username: '',
                flg_username: '',
                flg_userid: ''
            }*/
            console.log(`in Logon`)
            console.log(loggedon)
            // Send to Redux Store.
            dispatch(addauth(loggedon))
            dispatch(setAuth(loggedon))
            dispatch(fetchFolders())

            // Update the caller
            props.onChange({loggedon: true, ...loggedon })
            return
        }
    }

    return(
        <div className={classes.logonForm}>
            <img src={logo} alt='TTP Advisory CRM' className={classes.logo} width="150" /><br/>
            <form id='frmMain'>
                <InputLabel className={classes.label} htmlFor="username" id="lbluserName">Username</InputLabel>
                <Input id="username" name="username" value={username} onChange={(e) => setUsername(e.target.value)}  autoComplete="username" />
                <InputLabel className={classes.label} htmlFor="password" id="lblPassword">Password</InputLabel>
                <Input id="password" name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}  autoComplete="current-password" />
                <br/>&nbsp;<br/>
                <StyledButton variant="contained"  onClick={DoLogon} >Logon</StyledButton>
                <p>{error}</p>
            </form>
        </div>
    )
}

export default withStyles(styles)(Logon)